import { EventsName } from "../enums/eventsName";

/**
 * Maps document type to the corresponding event name for BigQuery logging
 * @param docType - The document type string
 * @returns The corresponding event name from EventsName enum, or undefined if no match found
 */
export const getViewDocumentEventName = (
  docType: string,
): string | undefined => {
  const docTypeToEventMap: Record<string, string> = {
    nar_letter: EventsName.NAR_LETTER_VIEWED,
    approval_letter: EventsName.APPROVAL_LETTER_VIEWED,
    filled_form: EventsName.FILLED_FORM_VIEWED,
    denial_letter: EventsName.DENIAL_LETTER_VIEWED,
  };

  return docTypeToEventMap[docType];
};

/**
 * Maps document type to the corresponding event name for BigQuery logging
 * Falls back to AUTH_STATUS_SCREEN_SHOWN if no specific event is found
 * @param docType - The document type string
 * @returns The corresponding event name from EventsName enum
 */
export const getViewDocumentEventNameWithFallback = (
  docType: string,
): string => {
  return getViewDocumentEventName(docType) || EventsName.NAR_LETTER_VIEWED;
};
